<template>
  <div>
    <transition name="fade">
      <div class="window">
        <div class="content" v-if="loaded">
          <div class="planet">
            <img
              class="planetIMG"
              height="60%"
              :src="
                require(`@/assets/medias/images/releases/${release.planet}`)
              "
            />
          </div>
          <div class="popup bsod container">
            <h2>orbital_care_package {{ release.number }}</h2>
            <h2 class="release-title">
              {{ release.title }}
            </h2>
            <div>
              <p v-html="release.text"></p>
              <p>
                To decipher all this mess and understand how it all began, close
                this panel and take a left turn to access the Galactic Library
              </p>
              <h2>Tracks:</h2>
              <div v-for="track in release.tracks" :key="track.id">
                <h3>
                  <a :href="track.link" target="_blank">{{ track.name }}</a
                  ><br />crewMember: {{ track.member }}
                </h3>
                <p>
                  {{ track.text }}
                </p>
              </div>
            </div>
            <nav class="nav">
              <a class="link" @click="closePopup()">CLOSE</a>
            </nav>
          </div>
        </div>
        <div v-else style="position: absolute; top: -33vh; left: 50%;">
          <Loader></Loader>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/utilities/Loader.vue";
export default {
  name: "PopupRelease",
  components: {
    Loader,
  },
  props: ["release"],
  data() {
    return {
      loaded: false,
    };
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
  },
  mounted() {
    setTimeout(() => (this.loaded = true), 1500);
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/landing-error.scss";
.window {
  position: absolute;
  min-width: 101vw;
  min-height: 101vh;
  top: 0;
  left: -1vh;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
}

.release-title {
  font-size: 2rem;
}

.content {
  z-index: 2;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
}

.planet {
  height: 100vh;
  width: 50vw;
  top: 0;
  left: 0;
  text-align: center;
}

.planetIMG {
  margin-top: 20vh;
}

.popup {
  display: inline-block;
  bottom: 100px;
  width: 50%;
  max-height: 80vh;
  text-align: center;
  overflow: scroll;
  padding-top: 0vh;
  padding-right: 5vw;
}

.nav {
  margin-top: 35px;
  text-align: center;

  .link {
    text-decoration: none;
    padding: 0 9px 2px 8px;

    &:hover,
    &:focus {
      background: $grey;
      color: $blue;
    }
  }
}

@media screen and (max-width: 750px) {
  p {
    font-size: 1.2rem;
  }

  .title {
    font-size: 1.7rem;
  }
}
</style>
